var popupSettings = document.getElementById('popup-settings');
if (popupSettings) {
    var exitEventTimeout = parseInt(popupSettings.getAttribute('data-exit-event-timeout'));
    var pageScrollPercentage = parseInt(popupSettings.getAttribute('data-page-scroll-percentage'));
    var enableOnPageScroll = popupSettings.getAttribute('data-enable-on-page-scroll') === 'true';
}

function subscribeClick(loc) {
    localStorage.setItem("edmssubscribed", true);
    window.location = loc;
}

function closeEdm() {
    document.getElementsByTagName('body')[0].classList.remove("edm-active");
}

function closeEdmForPeriod() {
    closeEdm();
    localStorage.setItem("edmsignore", new Date().toISOString());
}

var sessionBegin;
var checkEdmTimer;
var scrollEventListener;

function showEdm() {
    document.body.classList.add('edm-active');
    sessionStorage.removeItem("edmsshow");
    clearInterval(checkEdmTimer);
    document.removeEventListener("mouseleave", showEdm);
    document.querySelector("body").removeEventListener("mouseleave", showEdm);
}

function popupChecker() {
    let currentTime = new Date();
    let diff = Math.abs(currentTime - sessionBegin);
    let seconds = Math.abs(diff / 1000);

    if (seconds >= exitEventTimeout) {
        sessionStorage.setItem("edmsshow", true);
        clearInterval(checkEdmTimer);
        document.addEventListener("mouseleave", showEdm);
        document.querySelector("body").addEventListener("mouseleave", showEdm);

        if (enableOnPageScroll == 'True') {
            initPageScrollPercentage();
        }
    }
}

function isPopupIgnored() {
    let local = localStorage.getItem("edmsignore");
    let localSubscribed = localStorage.getItem("edmssubscribed");

    if (localSubscribed) {
        return true;
    } else if (local) {
        let closeDate = new Date(local);
        let now = new Date();
        let diff = Math.abs(closeDate - now);
        let diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));

        return diffDays < 30;
    } else {
        return false;
    }
}

function initSessionInterval() {
    let edmsession = sessionStorage.getItem("edmsinit");

    if (edmsession) {
        sessionBegin = new Date(edmsession);
    } else {
        sessionBegin = new Date();
        sessionStorage.setItem("edmsinit", sessionBegin.toISOString());
    }

    checkEdmTimer = setInterval(popupChecker, 50);
}

function getDocHeight() {
    var D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    )
}

function amountScrolled() {
    var winheight = window.innerHeight || (document.documentElement || document.body).clientHeight
    var docheight = getDocHeight()
    var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
    var trackLength = docheight - winheight
    var pctScrolled = Math.floor(scrollTop / trackLength * 100)

    if (pctScrolled >= pageScrollPercentage) {
        showEdm();
        window.removeEventListener("scroll", scrollHandler);
    }
}

function scrollHandler() {
    amountScrolled();
}

function initPageScrollPercentage() {
    window.addEventListener("scroll", scrollHandler, false)
}

function initPopup() {
    if (isPopupIgnored()) {
        return;
    }

    //else if (sessionStorage.getItem("edmsshow")) {
    //    setTimeout(() => {
    //        showEdm();
    //    }, 2000);
    //    return;
    //}

    initSessionInterval();
}

(function () {
    if (window.innerWidth <= 768) {
        return;
    }
    initPopup();
})()

window.closeEdmForPeriod = closeEdmForPeriod;
window.subscribeClick = subscribeClick;